import { render, staticRenderFns } from "./DisableTwoFactorAuthentication.vue?vue&type=template&id=61640bc2&"
import script from "./DisableTwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./DisableTwoFactorAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports